
/**module */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';;
import { UrlVariable } from '@util/variable';
import { LogService } from "@util/logHelper";
import { Observable } from "rxjs/Observable";
@Injectable()
export class CauHinhChungService {
    constructor(
        private http: HttpClient,
        private logger: LogService
    ) { }

    /**
     * @author Bình
     * đọc file excel
     */
    public decode = (body) => {
        return this.http.post(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/cauhinhchung/decode`, { file: body })
            .toPromise()
            .then(response => {
                return response;
            })
            .catch(error => {
                console.error('ERROR khi decodeExcel', error);
                return Promise.reject(error);
            })
    }

    /**
     * @author Bình
     * export excel
     */
    public export = (data) => {
        return this.http.post(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/cauhinhchung/buildexcel`, { data: data }, { responseType: 'text' })
            .toPromise()
            .then(response => {
                return response;
            })
            .catch(error => {
                return Promise.reject(error);
            })
    }
    /**
     * @author Võ 14-6-2017
     * Build excel trả về buffer để download
     */
    buildExcel(body): Promise<any> {
        return this.http.post(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/cauhinhchung/buildexcel`, body)
            .toPromise()
            .then(response => {
                return response;
            })
            .catch(error => {
                console.error('ERROR khi buildexcel', error);
                return Promise.reject(error);
            })
    }
    public getPDF = (content): Promise<any> => {
        return this.http.post(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/cauhinhchung/getPDF`, content)
            .toPromise()
            .then(response => response)
    }
    public getBlob = (url): Promise<any> => {
        return this.http.post(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/cauhinhchung/getblob`, { url: url })
            .toPromise()
            .then(response => response)
    }
    /**
     * @author Bình
     * lấy niên khóa
     */
    public getsNienKhoa = () => {
        return this.http.get(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/cauhinhchung/nien-khoa/get-nien-khoa`)
            .toPromise()
            .then(value => value['result'])
            .catch(error => {
                this.logger.saveLog(error)
                console.error('ERROR khi getsNienKhoa', error);
                return Promise.reject(error);
            })
    }
    /**
     * @author Quan
     * tich hop api dung cho cau hinh chung 
     */
    /**
     * @author Quân
     *  lấy lầu theo cơ sở 
     */
    getsLau = (idCoSo: number): Promise<any> => {
        let body = {};
        if (idCoSo != 0) {
            body['co_so_id'] = idCoSo;
        }
        return this.http.post(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/lau/get-list-by-co-so`, body)
            .toPromise()
            .then(value => value)
            .catch(err => Promise.reject(err));
    }
    /**
     * @author Quân
     *  lấy danh sách tất cả cơ sở
     */
    getsCoSo = (): Promise<any> => {
        return this.http.get(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/co-so/get-list-all`)
            .toPromise()
            .then(value => value)
            .catch(err => Promise.reject(err));
    }
    /**
     * @author Giai
     *  lấy list tiet theo phan he
     */
    getListTietHoc = (idPhanHe: number): Promise<any> => {
        let body = {};
        body['phan_he_dao_tao_id'] = idPhanHe;
        return this.http.post(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/tiet-hoc/get-list-theo-phan-he`, body)
            .toPromise()
            .then(value => value)
            .catch(err => Promise.reject(err));
    }
    /**
     * @author Quân Võ
     *  lấy đơn vị theo phân hệ id và user
     */
    getsDonVi = (idPhanHe: number): Promise<any> => {
        let body = {};
        body['phan_he_dao_tao_id'] = idPhanHe;
        return this.http.post(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/don-vi/get-don-vi-phan-he`, body)
            .toPromise()
            .then(value => value)
            .catch(err => Promise.reject(err));
    }
    /**
    * @author Quân Võ
    *  lấy tất cả hệ đào tạo
    */
    getsHeDaoTao = (): Promise<any> => {
        return this.http.get(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/he-dao-tao/get-phan-he-by-user`)
            .toPromise()
            .then(value => value)
            .catch(err => Promise.reject(err));
    }
    /**
     * @author Quân
     *  lấy danh sách phòng theo cơ sở theo lầu theo phân quyền
     */
    getsPhong = (body: any): Promise<any> => {
        return this.http.post(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/phong/get-list-by-co-so-lau`, body)
            .toPromise()
            .then(value => value)
            .catch(err => Promise.reject(err));
    }

    /**
     * 
     */
    traCuuPhong = (body: any): Observable<any> => {
        return this.http.post(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/phong/get-list-by-co-so-lau`, body).map(x => {
            return x["result"]
        })
    }

    /**
    * @author Quân
    *  lấy danh sách phòng theo cơ sở theo lầu KHÔNG theo phân quyền LIMIT 10
    */
    getsTatCaPhong = (body: any): Promise<any> => {
        return this.http.post(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/phong/get-all-by-co-so-lau`, body)
            .toPromise()
            .then(value => value)
            .catch(err => Promise.reject(err));
    }
    /**
    * @author Quân
    *  lấy niên khóa trong table: set_nam_hoc, database: hutech_giamsatgiangday
    */
    getsNamHoc = (): Promise<any> => {
        return this.http.get(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/nam-hoc/get-list-all`)
            .toPromise()
            .then(value => value)
            .catch(err => Promise.reject(err));
    }
    /**
    * @author Giai 25-10-2017
    *  lấy tinh chat phong trong table: set_phong, database: hutech_giamsatgiangday
    */
    getListTinhChatPhong = (): Promise<any> => {
        return this.http.get(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/phong/get-list-tinh-chat`)
            .toPromise()
            .then(value => value)
            .catch(err => Promise.reject(err));
    }
    /**
     * @author Võ 21-10-2017
     * Search thông tin nhân viên theo mã và họ tên
     */
    public searchNhanVien(body) {
        body['order'] = 'ho_ten+0';
        // body['diuu'] = 'tuts-manager';

        return this.http.post(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/nhan-vien/search`, body)
            .toPromise()
            .then(response => {
                return response;
            })
            // .then(jsonData => {
            //     let arrayNoiDung = [];
            //     jsonData.forEach(_d => {
            //         let _da: NhanVien = Object.assign(new NhanVien(), _d);
            //         arrayNoiDung.push(_da);
            //     })
            //     jsonData = arrayNoiDung;
            //     return jsonData;
            // })
            .catch(error => {
                this.logger.saveLog(error)
                console.error('ERROR khi search', error);
                return Promise.reject(error);
            })
    }

    /**
     * @author Võ 21-10-2017
     * Search thông tin nhân viên theo mã và họ tên
     */
    public searchNhanVienAutoComplete(body) {
        body['order'] = 'ho_ten+0';
        // body['diuu'] = 'tuts-manager';

        return this.http.post(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/nhan-vien/search`, body)
            .map(value => value)
    }
    /**
     * @author Bình
     * lấy tất cả đơn vị theo phân quyền user
     */
    public donViGetsByUser = (): Promise<any> => {
        return this.http.get(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/don-vi/gets-by-contactid`)
            .toPromise()
            .then(value => value['result'])
            .catch(error => {
                this.logger.saveLog(error)
                console.error('ERROR khi donViGets', error);
                return Promise.reject(error);
            })
    }

    /**
     * @author Bình
     * lấy tất cả phân hệ
     */
    public phanHeGetsAll = (): Promise<any> => {
        return this.http.get(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/he-dao-tao/get-list-all`)
            .toPromise()
            .then(value => value)
            .catch(error => {
                this.logger.saveLog(error)
                console.error('ERROR khi phanHeGetsAll', error);
                return Promise.reject(error);
            })
    }

    /**
     * @author Bình
     * lấy tất cả hay tìm kiếm đơn vị không theo phân quyền
     * nếu có truyền keyword -> tìm theo mã, tên đơn vị
     * limit có phân trang
     */
    public searchDonVis = (keyword, limit): Promise<any> => {
        let body = {};
        if (keyword)
            body["keyword"] = keyword
        if (limit) {
            body["limit"] = limit;
        }
        return this.http.post(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/don-vi/search`, body)
            .toPromise()
            .then(value => value['result'])
            .catch(error => {
                this.logger.saveLog(error)
                console.error('ERROR khi searchDonVis', error);
                return Promise.reject(error);
            })
    }

    /**
     * @author Bình
     * lấy năm học học kỳ 
     */
    public getsAllNamHocHocKy = () => {
        return this.http.get(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/nam-hoc/gets-nam-hoc-hoc-ky`)
            .toPromise()
            .then(value => value['result'])
            .catch(error => {
                this.logger.saveLog(error)
                console.error('ERROR khi getsAllNamHocHocKy', error);
                return Promise.reject(error);
            })
    }

    /**
     * @author Thành
     */
    public getLinkPDF = (content, filename) => {
        return this.http.post(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/cauhinhchung/htmlToPdf`, {
            html: content
        }, { responseType: 'text' })
            .subscribe((res) => {
                return this.http
                    .get(res, { responseType: "blob" })
                    .map(res => {
                        // console.log('download error:', res);
                        return {
                            filename: `${filename}.pdf`,
                            data: res,
                        };
                    })
                    .subscribe(res => {
                        // console.log('start download:',res);
                        const url = window.URL.createObjectURL(res.data);
                        const a = document.createElement('a');
                        document.body.appendChild(a);
                        a.setAttribute('style', 'display: none');
                        a.href = url;
                        a.download = res.filename;
                        a.click();
                        window.URL.revokeObjectURL(url);
                        a.remove(); // remove the element
                    }, error => {
                        // console.log('download error:', JSON.stringify(error));
                    }, () => {
                        // console.log('Completed file download.')
                    });
            }, error => {
                // console.log('get file Error', JSON.stringify(error));
            })
    }


    /**
     * @author Bình
     * dùng để search gợi ý đơn vị select2 của Võ
     */
    public searchDonVisSelect2 = (keyword, limit) => {
        let body = {};
        if (keyword)
            body["keyword"] = keyword
        if (limit) {
            body["limit"] = limit;
        }
        return this.http.post(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/don-vi/search`, body)
            .map(value => {
                let result = [];
                if (value['result']) {
                    result = value['result'].map(x => {
                        return { display: x.ten_don_vi, value: x.don_vi_id }
                    });
                }
                return result;
            })
    }


    /**
     * @author Bình
     * dùng để search gợi ý phòng select2 của Võ
     */
    public getsTatCaPhongAutoComplete = (body: any) => {
        return this.http.post(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/phong/get-all-by-co-so-lau`, body)
            .map(value => value['result'])
    }
    /* 
    lấy tất cả tôn giáo, dân tộc, tỉnh/ thành, quận/ huyện
    */
    public getAllTinhHuyenDanTocTonGiao = (): Promise<any> => {
        return this.http.get(`${UrlVariable.URL_API_CAU_HINH_CHUNG}/api/cauhinhchung/get-all-tinh-huyen-dan-toc-ton-giao`)
            .toPromise()
            .then(response => response)
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/cau-hinh-chung.service.ts